export const apiUrl = () => process.env.REACT_APP_API_URL;

export const editApiUrl = () => process.env.REACT_APP_EDIT_API_URL;
